export default function Card({ children, className = '' }) {
  return <div className={`rounded-2xl border-2 border-[#d8bf6b] bg-white p-4 shadow-sm ${className}`}>{children}</div>
}
